import classNames from 'classnames'
import { FlexColumn } from '@/atoms/FlexContainers'
import { LoadingSpinnerIcon } from '@/atoms/Icons/LoadingSpinnerIcon'
import { CaptionLG } from '@/atoms/Text'
import { useThemeContext } from '@/contexts/ThemeContext'
import { useTranslate } from '@/utils/translate/translate-client'

const ExpressProcessingOverlay = () => {
  const { t } = useTranslate('pif')
  const { isDarkMode } = useThemeContext()

  return (
    <FlexColumn
      className={classNames(
        'fixed inset-0 z-[101] items-center justify-center gap-6',
        isDarkMode ? 'bg-core-gray-950' : 'bg-core-gray-100',
      )}
    >
      <LoadingSpinnerIcon color="oxide-bright" size={64} />
      <CaptionLG color={isDarkMode ? 'core-gray-400' : 'core-gray-700'}>
        {t('processingYourorder', 'Processing Your Order')}
      </CaptionLG>
    </FlexColumn>
  )
}

export default ExpressProcessingOverlay
